import { SplitVideoboardComponent } from './split-videoboard/split-videoboard.component';
import { LeagueSettingComponent } from './league-setting/league-setting.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LeagueDetailsRoutingModule } from './league-details-routing.module';

import { LeagueDetailsComponent } from './league-details.component';
import { EmptyPageModule } from '../../empty-page/empty-page.module';
import { TranslateModule } from '@ngx-translate/core';
import { TeamItemComponentModule } from '../../my-teams/team-item/team-item.module';
import { TieSelectorModule } from '../../ties/tie-selector/tie-selector.module';
import { TeamSelectorModule } from '../../my-teams/team-selector/team-selector.module';
import { CreateTeamModule } from '../../my-teams/create-team/create-team.module';
import { TieScorecardModule } from '../../ties/tie-details/tie-scorecard/tie-scorecard.module';
import { LeagueOptionsComponent } from './league-options/league-options.component'
import { SelectUserModule } from '../../_shared/components/select-user/select-user.module';
import { DatetimeModule } from '../../_shared/components/datetime/datetime.module';
import { ShareMatchComponentModule } from '../../_shared/components/share-match/share-match.module';
import { LeagueDrawComponent } from './league-draw/league-draw.component';
import { TieMatchListModule } from '../../ties/tie-details/tie-match-list/tie-match-list.module';
import { LeaguePolicyComponent } from './league-policy/league-policy.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        LeagueDetailsRoutingModule,
        EmptyPageModule,
        TranslateModule.forChild(),
        TieScorecardModule,
        TeamItemComponentModule,
        TieSelectorModule,
        CreateTeamModule,
        TeamSelectorModule,
        SelectUserModule,
        DatetimeModule,
        ShareMatchComponentModule,
        TieMatchListModule,
        LeaguePolicyComponent
    ],
    declarations: [
        LeagueDetailsComponent,
        LeagueOptionsComponent,
        LeagueDrawComponent,
        LeagueOptionsComponent,
        LeagueSettingComponent,
        SplitVideoboardComponent
    ]
})
export class LeagueDetailsComponentModule { }
